import { SafePromise } from '@benzinga/safe-await';

import { RestfulClient, UUID } from '@benzinga/session';
import { ChartExtendedContent, ChartExtendedMetaInfo } from './entities';
import { Session } from '@benzinga/session';
import { ChartConfigEnvironment } from './environment';

export class ChartConfigRestful extends RestfulClient {
  constructor(session: Session) {
    super(session.getEnvironment(ChartConfigEnvironment).url, session, { authorization: true });
  }

  public getChartData = (chartGuid: UUID | number | null): SafePromise<ChartExtendedContent | null> => {
    const url = this.URL(`charts/${chartGuid}`);
    return this.get(url, {
      credentials: 'same-origin',
      resilience: { delayMultiple: 2000, delayOffset: 1000, maxDelay: 300000 },
    });
  };

  public putChartData = (
    chartGuid: UUID | null,
    chartState: ChartExtendedContent,
  ): SafePromise<{ guid: UUID } | null> => {
    const url = this.URL(`charts/${chartGuid}`);
    return this.put(url, chartState, { credentials: 'same-origin' });
  };

  public postChartData = (chart: Omit<ChartExtendedContent, 'guid'>): SafePromise<{ guid: UUID } | null> => {
    const url = this.URL(`charts`);
    return this.post(url, chart, { credentials: 'same-origin' });
  };

  public deleteChartData = (guid: UUID | number) => {
    const url = this.URL(`charts/${guid}`);
    return this.delete(url, { credentials: 'same-origin' });
  };

  public getCharts = (): SafePromise<{ charts: ChartExtendedMetaInfo[] }> => {
    const url = this.URL(`charts`);
    return this.get(url, { credentials: 'same-origin' });
  };
}
